import { render } from "./glasses.vue?vue&type=template&id=096a40d8"
import script from "./glasses.vue?vue&type=script&lang=js"
export * from "./glasses.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projekte/Seminarplattform/lernplattform-holistic-institut/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__